// Mock data for Hybionics website

export const products = [
  {
    id: 1,
    name: "Smart Prosthetic Socket",
    description: "Advanced prosthetic sockets with integrated sensing technology for real-time monitoring and optimal comfort.",
    features: [
      "Integrated flexible humidity, pressure & IMU sensors",
      "Auto fit technology",
      "Climate control system",
      "Fall detection and prevention",
      "Real-time monitoring",
      "Personalized aesthetics"
    ],
    image: "https://customer-assets.emergentagent.com/job_access-limbs/artifacts/gmib0gto_Gemini_Generated_Image_e46pn7e46pn7e46p.png",
    price: "Contact for pricing"
  },
  {
    id: 2,
    name: "3D Prosthetic Foam Covers",
    description: "Lightweight, protective foam cover plates that provide cushioning and aesthetic finish for prosthetic devices.",
    features: [
      "Lightweight design",
      "Custom-fit & sound limb geometry",
      "Rubber feel & finish",
      "Waterproof construction",
      "Impact protection",
      "Custom design and color"
    ],
    image: "https://customer-assets.emergentagent.com/job_access-limbs/artifacts/xchwzeta_WhatsApp%20Image%202025-11-01%20at%2021.22.48.jpeg",
    price: "Contact for pricing"
  },
  {
    id: 3,
    name: "R & D Custom Designed 3D Accessories",
    description: "Innovative research and development prototypes for custom 3D printed prosthetic and orthotic accessories tailored to individual needs.",
    features: [
      "Custom 3D sockets and 3D liner",
      "Custom 3D cosmesis molds",
      "Custom 3D insoles",
      "Custom portable vacuum suspension",
      "Prototype development",
      "User-centric innovation"
    ],
    image: "https://customer-assets.emergentagent.com/job_access-limbs/artifacts/pwhb6ofl_Gemini_Generated_Image_6t32x6t32x6t32x6.png",
    price: "Contact for pricing"
  }
];

export const labSetupFeatures = [
  {
    id: 1,
    title: "Complete 3D Lab Setup",
    description: "Everything you need to start providing custom prosthetics and orthotics at your clinic.",
    includes: [
      "3D printer and scanning equipment",
      "Design software and training",
      "Quality assurance protocols",
      "Material supply chain access",
      "Initial setup support",
      "Technical documentation"
    ]
  },
  {
    id: 2,
    title: "Training & Support",
    description: "Comprehensive training programs to ensure your team can deliver exceptional care.",
    includes: [
      "Hands-on training sessions",
      "Online learning resources",
      "Technical support access",
      "Best practices documentation",
      "Regular knowledge updates",
      "Community network access"
    ]
  },
  {
    id: 3,
    title: "Partnership Benefits",
    description: "Join the HyBionics network and bring accessible prosthetic care to your community.",
    includes: [
      "Collaborative business model",
      "Technology licensing",
      "Marketing materials",
      "Quality standards support",
      "Innovation collaboration",
      "Brand partnership"
    ]
  }
];

export const technologies = [
  {
    id: 1,
    title: "Advanced 3D Scanning",
    description: "Precise digital scanning captures every contour for perfect fit and comfort.",
    icon: "Scan"
  },
  {
    id: 2,
    title: "Smart Sensing",
    description: "Real-time pressure monitoring and feedback for optimal socket performance.",
    icon: "Activity"
  },
  {
    id: 3,
    title: "Custom Design",
    description: "User-centric design process ensures both functionality and personal expression.",
    icon: "Palette"
  },
  {
    id: 4,
    title: "Rapid Manufacturing",
    description: "Decentralized production delivers custom devices in days, not weeks.",
    icon: "Zap"
  },
  {
    id: 5,
    title: "Quality Materials",
    description: "Medical-grade materials ensure durability, comfort, and safety.",
    icon: "Award"
  },
  {
    id: 6,
    title: "Local Production",
    description: "Clinic-based labs reduce costs and increase accessibility for all patients.",
    icon: "MapPin"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Prathmesh Patole",
    role: "Certified P&O, Owner of Samarthya Clinic, Mumbai",
    content: "HyBionics' approach to decentralized 3D printing is exactly what the industry needs. The quality and customization of their prosthetic sockets are impressive for an early-stage startup.",
    rating: 5
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    role: "Patient, Delhi",
    content: "Earlier, the regular foam covers felt bulky and awkward — I used to feel embarrassed wearing them. But this 3D-printed one is incredible! It's sleek, comfortable, and makes me feel confident. 3D technology has truly changed the experience for the better.",
    rating: 5
  },
  {
    id: 3,
    name: "Dr. Anjali Mehta",
    role: "Prosthetist, Delhi NCR",
    content: "The sensing technology integrated into their sockets provides valuable data for optimizing fit. Looking forward to seeing how their clinic partnership program develops.",
    rating: 5
  },
  {
    id: 4,
    name: "Amit Patel",
    role: "Parent, Pune",
    content: "HyBionics Pediatric Team designed a custom Barbie themed prosthetic foam cover for my Daughter. The team was patient and made sure every detail was right. Grateful for their innovation and care.",
    rating: 5
  }
];

export const stats = [
  { label: "Custom Devices Delivered", value: "10+" },
  { label: "Partner Clinics Across India", value: "3" },
  { label: "R&D Prototypes in Testing", value: "2" },
  { label: "Granted Patent", value: "1" },
  { label: "Grants & Awards", value: "8+" }
];

// Form submission mock
export const submitContactForm = async (formData) => {
  // Simulate API call
  await new Promise(resolve => setTimeout(resolve, 1000));
  console.log("Form submitted:", formData);
  return { success: true, message: "Thank you! We'll contact you within 24 hours." };
};

export const submitLabInquiry = async (formData) => {
  // Simulate API call
  await new Promise(resolve => setTimeout(resolve, 1000));
  console.log("Lab inquiry submitted:", formData);
  return { success: true, message: "Thank you for your interest! Our team will reach out soon." };
};

export const submitProductInquiry = async (formData) => {
  // Simulate API call
  await new Promise(resolve => setTimeout(resolve, 1000));
  console.log("Product inquiry submitted:", formData);
  return { success: true, message: "Thank you! We'll get back to you shortly." };
};